<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-5">
			<h1 class="titolo-bertazzoni">ADDING PORTAL USER</h1>
		</div>
		<div class="row">
			<div class="col-12 col-md-6 mx-auto">
				<form #form="ngForm">
					<label for="" class="font-weight-bold font-12">USERNAME</label>
					<input
						type="text"
						class="form-control rounded-0 form-bertazzoni white mb-2"
						placeholder="USERNAME"
						required
						name="user"
						[(ngModel)]="jsonIn.username" />
					<label for="" class="font-weight-bold font-12">EMAIL (multiple emails separated by comma)</label>
					<input
						type="text"
						class="form-control rounded-0 form-bertazzoni white mb-2"
						placeholder="email1@example.com, email2@example.com"
						required
						name="mail"
						[(ngModel)]="jsonIn.email" />
					<label *ngIf="!jsonIn.id" for="" class="font-weight-bold font-12">PASSWORD</label>
					<input
						*ngIf="!jsonIn.id"
						type="text"
						class="form-control rounded-0 form-bertazzoni white mb-2"
						placeholder="PASSWORD"
						required
						name="pass"
						[(ngModel)]="jsonIn.password" />
					<label for="" class="font-weight-bold font-12">ROLE</label>
					<select class="minimal rounded-0 border-black w-100 mb-2" name="ruolo" [(ngModel)]="jsonIn.ruolo" required>
						<option [ngValue]="null">SELECT</option>
						<option value="ADMIN">Admin</option>
						<option value="BACKOFFICE">Backoffice</option>
						<option value="CLIENTE">Customer</option>
						<option value="PARTNER">Partner</option>
						<!-- <option value="SPEDIZIONIERE">Spedizioniere</option>
						<option value="AGENTE_INTERNO">Agente interno</option>
						<option value="AGENTE_ESTERNO">Agente esterno</option> -->
					</select>
					<label for="" class="font-weight-bold font-12">ASSOCIATED CUSTOMER</label>
					<select class="minimal rounded-0 border-black w-100 mb-2" name="cliente" [(ngModel)]="jsonIn.idCliente" required>
						<option [ngValue]="null">SELECT</option>
						<option *ngFor="let cliente of clienti" [value]="cliente.id">{{cliente.ragioneSociale}}</option>
					</select>

					<label for="" class="font-weight-bold font-12">ASSOCIATED COMPANY</label>
					<select class="minimal rounded-0 border-black w-100 mb-2" name="company" [(ngModel)]="jsonIn.idCompany" required>
						<option [ngValue]="null">SELECT</option>
						<option *ngFor="let company of listaCompany" [value]="company.id">{{company.descrizione}}</option>
					</select>

					<div class="markets-container mb-3" [class.d-none]="jsonIn.ruolo !== 'PARTNER'">
						<label for="" class="font-weight-bold font-12">MARKETS</label>
						<ng-multiselect-dropdown
							*ngIf="mercati"
							name="mercati"
							class="multiselect-cms w-100"
							[placeholder]="'Seleziona'"
							[data]="mercati"
							[(ngModel)]="jsonIn.idMercati"
							[settings]="dropdownSettings"
							[required]="jsonIn.ruolo === 'PARTNER'"></ng-multiselect-dropdown>
					</div>

					<label *ngIf="jsonIn.ruolo === 'CLIENTE'" for="" class="font-weight-bold font-12">DISCOUNTS ENABLED</label>
					<input
						*ngIf="jsonIn.ruolo === 'CLIENTE'"
						type="checkbox"
						class="form-control checkbox  mb-2"
						placeholder="SCONTI ABILITATI"
						name="abilitaSconti"
						[(ngModel)]="jsonIn.abilitaSconti" />
					<label for="" class="font-weight-bold font-12">ACTIVE LEAD TIME</label>
					<input
						type="checkbox"
						class="form-control checkbox  mb-2"
						placeholder="LEAD TIME"
						name="leadTime"
						[(ngModel)]="jsonIn.leadTimeAttivo" />
					<!-- <label for="" class="font-weight-bold font-12">VISIBILITÁ CONTAINERIZZAZIONE CARRELLO</label>
					<input type="checkbox" class="form-control checkbox  mb-2" name="contCarrello" [(ngModel)]="jsonIn.containerizzazioneCarrello" />
					<label for="" class="font-weight-bold font-12">VISIBILITÁ CONTAINERIZZAZIONE ORDINI</label>
					<input type="checkbox" class="form-control checkbox  mb-2" name="contOrdini" [(ngModel)]="jsonIn.containerizzazioneOrdini" /> -->
					<button type="button" class="btn btn-bertazzoni black rounded-0 mt-4" [disabled]="form.invalid" (click)="aggiungi()">SAVE</button>
				</form>
			</div>
		</div>
	</div>
</div>
